import React from 'react';
import PropTypes from 'prop-types';

export default function TCIOnlyLock({ classes }) {
  return <i aria-label="TCI only" className={`fa fa-lock ${classes}`} />;
}

TCIOnlyLock.propTypes = { classes: PropTypes.string };
TCIOnlyLock.defaultProps = { classes: '' };
